module.exports = __webpack_public_path__ + "static/media/otros.6229d2d7.svg";